export default __webpack_public_path__ + "static/media/audio.8ba831ff.svg";